import styled from 'styled-components';
import { fontWeight, spacer } from 'settings/style';

export const PanelHeader = styled.span`
  font-weight: ${fontWeight.bold};
`;

export const CategoryTreeLevel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer.sm};
`;

export const CategoryBranchCollapse = styled.div`
  .ant-collapse {
    border: none;
    background: transparent;
  }

  .ant-collapse-item {
    border: 1px solid #e8eaef;
    border-radius: 8px;
    margin-bottom: ${spacer.sm};
    overflow: hidden;
  }

  .ant-collapse-header {
    font-weight: ${fontWeight.bold};
  }
`;
